import { KolumnaSpisuFiltrowanie } from "../spis/kolumnaSpisuFiltrowanie";

export class PobierzNadwyzkiDoParowaniaFiltry {
    kolumnyFiltrowania: Array<KolumnaSpisuFiltrowanie> = new Array();
    idLokalizacji: string;
    idProjektu: string;
    rekordEwidencjiDoSparowaniaId: string;
    czySugerowacPodobne: boolean;
    czyPokazacSparowaneSrodki: boolean;
}